import { useState } from 'react';

export function CommentForm() {
  const [name, setName] = useState('');
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simular envío
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccess(true);
      setName('');
      setComment('');
      
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }, 1000);
  };

  return (
    <div className="mt-3 sm:mt-4 md:mt-6 pt-3 sm:pt-4 md:pt-6 border-t border-white/10">
      <h4 className="text-white font-semibold text-[10px] sm:text-xs md:text-sm lg:text-base mb-2 sm:mb-3 md:mb-4 flex items-center gap-1.5 sm:gap-2">
        <i className="ri-chat-3-line text-emerald-400"></i>
        Agrega tu comentario
      </h4>
      
      {showSuccess && (
        <div className="mb-3 p-2 bg-emerald-500/20 border border-emerald-500/50 rounded-lg text-emerald-300 text-xs sm:text-sm">
          ¡Comentario publicado exitosamente!
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-1.5 sm:space-y-2 md:space-y-3">
        <div>
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Tu nombre"
            className="w-full bg-white/10 border border-white/20 rounded-md sm:rounded-lg px-2 py-1.5 sm:px-3 sm:py-2 md:px-4 md:py-2 text-white placeholder-white/50 text-[10px] sm:text-xs md:text-sm focus:outline-none focus:border-emerald-400 focus:bg-white/15 transition-all"
            required
          />
        </div>
        <div>
          <textarea
            name="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Escribe tu comentario aquí..."
            rows={3}
            maxLength={500}
            className="w-full bg-white/10 border border-white/20 rounded-md sm:rounded-lg px-2 py-1.5 sm:px-3 sm:py-2 md:px-4 md:py-2 text-white placeholder-white/50 text-[10px] sm:text-xs md:text-sm focus:outline-none focus:border-emerald-400 focus:bg-white/15 transition-all resize-none"
            required
          ></textarea>
          <p className="text-white/40 text-[9px] sm:text-xs mt-0.5 sm:mt-1 text-right">
            {comment.length}/500
          </p>
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:via-emerald-700 hover:to-teal-600 text-white font-semibold py-1.5 sm:py-2 md:py-2.5 px-3 sm:px-4 md:px-6 rounded-md sm:rounded-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs md:text-sm whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <i className="ri-send-plane-fill"></i>
          {isSubmitting ? 'Publicando...' : 'Publicar comentario'}
        </button>
      </form>
    </div>
  );
}
